export default "__VITE_ASSET__960MZsl8__"